<template>
  <v-tooltip v-if="genetic" bottom>
    <template #activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <v-img
          contain
          width="25px"
          height="25px"
          :src="require(`@/assets/img/icons_orders/${genetic.id}.svg`)"
        />
      </span>
    </template>
    <span>{{ genetic.description }}</span>
  </v-tooltip>
</template>

<script>
  export default {
    name: 'SpecialGeneticsIcons',
    props: {
      genetics: {
        type: String,
        required: true,
      },
    },
    data: () => ({
      validateGenetic: [
        { id: 'N', description: 'Producto Nuevo en Catálogo' },
        { id: 'D', description: 'Producto Descontinuado' },
        { id: 'O', description: 'Producto Obsoleto' },
        { id: 'A', description: 'Producto Alta Rotación' },
        { id: 'B', description: 'Producto Media Rotación' },
        { id: 'C', description: 'Producto Bajo Pedido' },
      ],
    }),

    computed: {
      genetic() {
        return this.validateGenetic.find((g) => g.id === this.genetics);
      },
    },
  };
</script>
